// 環境変数で北マーク（Nマーク）機能を制御
export const SHOW_NORTH_INDICATOR =
  process.env.REACT_APP_SHOW_NORTH_INDICATOR === "true";

export const NORTH_INDICATOR_DEFAULT =
  process.env.REACT_APP_NORTH_INDICATOR_DEFAULT === "true";

export const NORTH_INDICATOR_COLOR =
  process.env.REACT_APP_NORTH_INDICATOR_COLOR;
